<div class="seccion">
  <div class="head">
    <div class="head-texto">
      <h2>Categorías del cliente</h2>
      <p class="nota">
        Cada categoría define qué botones ve el vecino y en qué pantalla. Al
        vecino se le asigna una: la marcada como
        <strong>Default</strong>, o la que corresponda por edad.
      </p>
    </div>
    <button mat-flat-button color="primary" type="button" (click)="agregar()">
      <mat-icon>add</mat-icon> Agregar categoría
    </button>
  </div>

  <!-- El cliente tiene pantalla hecha a mano en la app: se avisa una sola vez, arriba. -->
  @if (templateCustom) {
    <div class="aviso custom">
      <mat-icon>phonelink_lock</mat-icon>
      <div>
        <strong>Template personalizado: {{ templateCustom.label }}.</strong>
        La pantalla de inicio está escrita a mano en la app mobile y se resuelve
        por el bundle ID del cliente, así que la botonera no se elige en ninguna
        categoría. Sí se configuran los botones, las pantallas, la variante y las
        imágenes.
      </div>
    </div>

    @if (templateClientePisado) {
      <div class="aviso error">
        <mat-icon>error_outline</mat-icon>
        <div>
          <strong>
            El cliente tiene guardada la botonera genérica
            "{{ templateClientePisado }}".
          </strong>
          En la app ese valor le gana al template del bundle ID, así que
          {{ templateCustom?.label }} no se está usando en ninguna pantalla.
          Está en App Nativa → Plantilla base del cliente.
          <button
            mat-stroked-button
            color="warn"
            type="button"
            (click)="limpiarTemplateCliente()"
          >
            <mat-icon>backspace</mat-icon> Quitarla y volver al template propio
          </button>
        </div>
      </div>
    }
  }

  @if (faltaCategoria) {
    <div class="aviso error">
      <mat-icon>error_outline</mat-icon>
      El cliente necesita al menos una categoría.
    </div>
  }
  @if (faltaDefault) {
    <div class="aviso error">
      <mat-icon>error_outline</mat-icon>
      <div>
        <strong>Falta la categoría por defecto.</strong> Es la que se le asigna
        al vecino que no cae en ningún rango de edad. Tocá la
        <mat-icon class="ic-inline">star_border</mat-icon> de la card que
        quieras usar. Sin esto no se puede guardar el cliente.
      </div>
    </div>
  }

  <!-- ============================ CARDS ============================ -->
  @for (ed of categorias; track ed.idCategoria; let i = $index) {
    <div class="card" [class.abierta]="expandida === i">
      <div class="card-head">
        <button
          mat-icon-button
          type="button"
          class="estrella"
          [class.on]="esDefault(ed)"
          [class.falta]="faltaDefault"
          [matTooltip]="
            esDefault(ed)
              ? 'Es la categoría por defecto'
              : faltaDefault
                ? 'Marcar como default (obligatorio para guardar)'
                : 'Marcar como default'
          "
          (click)="marcarDefault(ed)"
        >
          <mat-icon>{{ esDefault(ed) ? "star" : "star_border" }}</mat-icon>
        </button>

        <div class="card-titulo" (click)="toggle(i)">
          <strong>{{ etiqueta(ed) }}</strong>
          <div class="meta">
            @if (ed.nueva) {
              <span class="pill nueva">nueva · se crea al guardar</span>
            }
            <span class="pill" [matTooltip]="tooltipBotonera(ed)">
              {{ etiquetaBotonera(ed) }}
            </span>
            <span>botones {{ resumenBotones(ed) }}</span>
            @if (ed.compartidaCon.length) {
              <span
                class="pill compartida"
                [matTooltip]="ed.compartidaCon.join(', ')"
              >
                compartida · {{ ed.compartidaCon.length }} cliente(s)
              </span>
            } @else if (!ed.nueva) {
              <span class="pill exclusiva">solo este cliente</span>
            }
            <!-- Cuántos vecinos la tienen vigente: es lo que hay que reasignar si se la quita. -->
            @if (vecinosVigentesDe(ed.idCategoria)) {
              <span
                class="pill vecinos"
                matTooltip="Si sacás esta categoría hay que decir a qué categoría pasan estos vecinos"
              >
                {{ vecinosVigentesDe(ed.idCategoria) }} vecino(s)
              </span>
            }
            @for (r of rangosDe(ed); track r) {
              <span class="pill edad">{{ r }}</span>
            }
          </div>
        </div>

        <button
          mat-icon-button
          type="button"
          matTooltip="Quitar del cliente"
          color="warn"
          (click)="eliminar(i)"
        >
          <mat-icon>delete</mat-icon>
        </button>
        <button
          mat-icon-button
          type="button"
          [matTooltip]="expandida === i ? 'Cerrar' : 'Editar'"
          (click)="toggle(i)"
        >
          <mat-icon>{{
            expandida === i ? "expand_less" : "expand_more"
          }}</mat-icon>
        </button>
      </div>

      @if (expandida === i) {
        <div class="card-body">
          <!-- Alcance: editar una categoría compartida la cambia para todos. -->
          @if (ed.compartidaCon.length) {
            <div class="aviso alcance">
              <mat-icon>groups</mat-icon>
              <div>
                <strong>Categoría compartida.</strong>
                También la usan: {{ ed.compartidaCon.join(", ") }}. Lo que
                edites acá lo ven esos clientes.
              </div>
              <button mat-stroked-button type="button" (click)="clonar(i)">
                <mat-icon>content_copy</mat-icon> Clonar para este cliente
              </button>
            </div>
          }

          <app-categoria-detalle
            [editable]="ed"
            [templateCustom]="templateCustom"
            [nombreCliente]="nombreCliente"
            [clienteFormValue]="clienteFormValue"
            [sirenas]="sirenas"
            [botonesCatalogo]="botonesCatalogo"
          />
        </div>
      }
    </div>
  }

  <!-- ============================ POR EDAD ============================ -->
  <div class="por-edad" [formGroup]="formulario">
    <h3>Asignación por edad (opcional)</h3>
    <p class="nota">
      Si la edad del vecino cae en un rango, se le asigna esa categoría en lugar
      de la default. Los rangos no se pueden solapar.
    </p>

    @if (rangosInvalidos) {
      <div class="aviso error">
        <mat-icon>error_outline</mat-icon>
        Hay rangos con "desde" mayor que "hasta", o que se solapan entre sí.
      </div>
    }

    <div formArrayName="categoriasDefault">
      @for (fila of categoriasDefault.controls; track $index; let i = $index) {
        <div class="fila-edad" [formGroupName]="i">
          <mat-form-field appearance="outline">
            <mat-label>Desde (años)</mat-label>
            <input matInput type="number" formControlName="desde" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Hasta (años)</mat-label>
            <input matInput type="number" formControlName="hasta" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="crece">
            <mat-label>Categoría</mat-label>
            <mat-select formControlName="idCategoria">
              @for (ed of categorias; track ed.idCategoria) {
                <mat-option [value]="ed.idCategoria">
                  {{ etiqueta(ed) }}
                </mat-option>
              }
            </mat-select>
            <mat-hint>Solo las de este cliente.</mat-hint>
          </mat-form-field>
          <button
            mat-icon-button
            color="warn"
            type="button"
            matTooltip="Eliminar rango"
            (click)="eliminarPorEdad(i)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      } @empty {
        <p class="nota">Sin rangos: todos los vecinos usan la default.</p>
      }
    </div>

    <button
      mat-stroked-button
      color="primary"
      type="button"
      [disabled]="!categorias.length"
      (click)="agregarPorEdad()"
    >
      <mat-icon>add</mat-icon> Agregar rango de edad
    </button>
  </div>
</div>
